<script>
import bienIciMap from '@utils/bien-ici-map'

export default {
  extends: bienIciMap,

  props: {
    accommodation: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      mapOptions: {
        zoom: 18,
        lon: this.accommodation.attributes.longitude,
        lat: this.accommodation.attributes.latitude
      }
    }
  },

  methods: {
    onLoad (_realEstateAd, map) {
      new L.Marker(
        {
          lat: this.accommodation.attributes.latitude,
          lng: this.accommodation.attributes.longitude
        },
        {
          icon: L.divIcon({
            className: `bg-map-icon transition transition-colors duration-300 flex justify-center font-sans text-xs font-medium text-white rounded icon-marker`,
            html: `<p>${this.accommodation.attributes.price}</p>`,
            iconSize: [80, 20],
            iconAnchor: [80 / 2, 0]
          })
        })
        .addTo(map)

      new L.Circle(
        [
          this.accommodation.attributes.latitude,
          this.accommodation.attributes.longitude
        ],
        100,
        {
          color: '#21ABD0',
          opacity: 0,
          fillOpacity: 0.35
        }
      ).addTo(map)
    }
  }
}
</script>
